export const areaConstants = ["Triceps", "Back", "Chest", "Legs", "Glutes", "Hamstrings", "Abs", "Shoulders"]